// extracted by mini-css-extract-plugin
export var actionText = "_nw-4";
export var container = "_nw-0";
export var leftSection = "_nw-1";
export var rightSection = "_nw-2";
export var settingsButton = "_nw-6";
export var settingsIcon = "_nw-7";
export var shortcut = "_nw-5";
export var shortcutGroup = "_nw-3";